import { Typography } from "@mui/material";
import { FC } from "react";
import InputText from "../../../components/InputText";
import { getEmailValidationRules } from "../../../helpers/formValidationRules";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import Button from "../../../components/Button";
import useRecoverPasswordMutation from "../hooks/useRecoverPasswordMutation";
import { useTranslation } from "react-i18next";

interface ResetPasswordFormProps {
  onSuccess?: (val?: string) => void;
}

const ResetPasswordForm: FC<ResetPasswordFormProps> = ({ onSuccess }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { control, watch, handleSubmit } = useForm({
    defaultValues: {
      email: "",
    },
  });

  const { mutate: recoverPasswordMutate, isPending: isSendingRequest } =
    useRecoverPasswordMutation(onSuccess);

  return (
    <>
      <Typography textTransform="capitalize" fontWeight={700} variant="h5">
        {t("Reset_password")}
      </Typography>
      <Typography mt={1}>{t("Recover_username_subheading")}</Typography>
      <InputText
        isLabelDefaultBehaviour
        name="email"
        control={control}
        label={t("Email_address")}
        rules={getEmailValidationRules()}
        //@ts-ignore
        color="custom.foreground.primary"
        sx={{
          my: 3,
        }}
      />

      <Button
        onClick={handleSubmit((val) => {
          recoverPasswordMutate(val);
        })}
        type="submit"
        variant="contained"
        fullWidth
        disabled={!watch("email") || isSendingRequest}
        sx={{
          mb: 3,
          backgroundColor: "custom.background.brand",
          textTransform: "none",
          fontSize: 16,
        }}
      >
        {t("Submit")}
      </Button>
      <Button
        fullWidth
        onClick={() => navigate(-1)}
        sx={{
          fontSize: 16,
          backgroundColor: "custom.background.primary",
          color: "custom.foreground.secondary",
        }}
      >
        {t("Cancel_and_go_back")}
      </Button>
    </>
  );
};

export default ResetPasswordForm;
